// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lj-0";